// extracted by mini-css-extract-plugin
module.exports = {"footerText":"PrivacyPolicy_footerText__H-heI","link":"PrivacyPolicy_link__30KmN","privacyAndTerms":"PrivacyPolicy_privacyAndTerms__297bk"};